export enum ToolsEnum {
    GOOGLE_SEARCH = 'Google Search',
    TWITTER_SEARCH = 'Twitter Search',
    GOOGLE_NEWS_SEARCH = 'Google News Search',
    GOOGLE_IMAGE_SEARCH = 'Google Image Search',
    BING_SEARCH = 'Bing Search',
    WIKIPEDIA_SEARCH = 'Wikipedia Search',
    YOUTUBE_SEARCH = 'Youtube Search',
    ArXiv_SEARCH = 'ArXiv Search',
    REDDIT_SEARCH = 'Reddit Search',
    HACKER_NEWS_SEARCH = 'Hacker News Search',
}

type ToolsListType = {
    name: ToolsEnum
    label: string
    descritpion: string
    icon: string
}

export const useTools = () => {
    const tools: ToolsListType[] = [
        {
            name: ToolsEnum.TWITTER_SEARCH,
            label: 'Twitter',
            descritpion: 'Access latest Twitter posts.',
            icon: 'https://img.freepik.com/free-vector/new-2023-twitter-logo-x-icon-design_1017-45418.jpg?size=338&ext=jpg&ga=GA1.1.2008272138.1723680000&semt=ais_hybrid',
        },
        {
            name: ToolsEnum.GOOGLE_SEARCH,
            label: 'Google',
            descritpion: "Web search using Google's engine.",
            icon: 'https://53.fs1.hubspotusercontent-na1.net/hub/53/hubfs/image8-2.jpg?width=600&name=image8-2.jpg',
        },
        {
            name: ToolsEnum.GOOGLE_NEWS_SEARCH,
            label: 'Google News',
            descritpion: 'Search news via Google.',
            icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqHxioda3at4AqjpGwSC3DghFQzcpCfNQPRw&s',
        },

        {
            name: ToolsEnum.GOOGLE_IMAGE_SEARCH,
            label: 'Google Image',
            descritpion: 'Search images via Google.',
            icon: 'https://53.fs1.hubspotusercontent-na1.net/hub/53/hubfs/image8-2.jpg?width=600&name=image8-2.jpg',
        },
        {
            name: ToolsEnum.BING_SEARCH,
            label: 'Bing',
            descritpion: "Web search using Bing's engine.",
            icon: 'https://cdn.vox-cdn.com/thumbor/lw7eaG_tnqPDo-Jy5CVzQ22WyCY=/0x0:660x440/1400x1050/filters:focal(330x220:331x221)/cdn.vox-cdn.com/uploads/chorus_asset/file/21937385/binglogo.jpg',
        },
        {
            name: ToolsEnum.WIKIPEDIA_SEARCH,
            label: 'Wikipedia',
            descritpion: 'Search content on Wikipedia.',
            icon: 'https://upload.wikimedia.org/wikipedia/en/thumb/8/80/Wikipedia-logo-v2.svg/2244px-Wikipedia-logo-v2.svg.png',
        },
        {
            name: ToolsEnum.YOUTUBE_SEARCH,
            label: 'Youtube',
            descritpion: 'Search videos on YouTube.',
            icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQoiMtJG_PC4lsb3-GZAiTZkUXAm3VlkJC1Ag&s',
        },
        {
            name: ToolsEnum.ArXiv_SEARCH,
            label: 'ArXiv',
            descritpion: 'Search academic papers on ArXiv.',
            icon: 'https://storage.googleapis.com/kaggle-datasets-images/612177/5023398/ed4470482e04000d11d3de82e2fb4389/dataset-card.png?t=2023-02-22-23-00-49',
        },
        {
            name: ToolsEnum.REDDIT_SEARCH,
            label: 'Reddit',
            descritpion: 'Search content on Reddit.',
            icon: 'https://images.squarespace-cdn.com/content/v1/5c5554d316b64061c6f8a20d/1630949829757-WXNOUZ8R4QQCXMIY4YMG/What-Is-The-Reddit-Logo-Called.png',
        },
        {
            name: ToolsEnum.HACKER_NEWS_SEARCH,
            label: 'Hacker News',
            descritpion: 'Search content on Hacker News.',
            icon: 'https://avatars.githubusercontent.com/u/4703068?s=280&v=4',
        },
    ]

    return { tools }
}
